/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';

	const slide = () => {
		var $slider02 = $('.index-slider02'),
			$slider02_nav = $('.index-slider02-nav');
		// アイテムが4以下の場合ナビ固定
		if(4 >= $('.index-slider02 ._item').length) {
			$slider02_nav.addClass(f);
		}
		// ナビゲーション用に複製
		$slider02_nav.append($slider02.contents().clone());
		$slider02.slick({
			asNavFor: $slider02_nav,
			infinite: true,
			autoplay: true,
			dots: false,
			arrows: true,
			prevArrow: '<a class="slick-prev opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
			nextArrow: '<a class="slick-next opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
			pauseOnHover: false,
			fade:true,
			waitForAnimate:false,
			autoplaySpeed: 5000,
			speed: 1000,
			responsive: [{
				breakpoint: 768,
				settings: {
					infinite: true,
				}
			}]
		});
		$slider02_nav.slick({
			asNavFor: $slider02,
			slidesToShow: 4,
			waitForAnimate:false,
			arrows: false,
			focusOnSelect: true
		});
		$('.index-slider02-nav ._title').matchHeight();
		$('.index-slider02-nav ._title2').matchHeight();
		$('.index-slider02-nav ._lead').matchHeight();
		$('.index-slider02-nav figure').matchHeight();
		$slider02.on('afterChange', function(slick, currentSlide){
			$('.index-slider02-nav ._title').matchHeight();
			$('.index-slider02-nav ._title2').matchHeight();
			$('.index-slider02-nav ._lead').matchHeight();
			$('.index-slider02-nav figure').matchHeight();
		});
	}

	slide();

	if(document.getElementsByClassName("js-index-toggleBlock").length > 0) {
		var $switch = $('.js-index-toggleButton');
		$switch.on('click', function(){
			$('.js-index-toggleBlock').toggleClass(a);
			$('.js-index-toggleButton').toggleClass(a);
		});
	}

})(window.jQuery, window.FUNCTIONS);

$(window).on('load', function(){
	const indexMain = () => {
		var cssua = window.cssua || null;
		const a = 'is-active';
		if($('.index-slider01-nav').length) {
			for(let i=0; i < $('.index-slider01-item-bg').length; i++) {
				let img = $('.index-slider01-item-bg').eq(i).data('img');
				let navHeight;
				$('.index-slider01-item-bg').eq(i).css('background-image', 'url('+img+')');
				if($(window).width() < 1025) {
					navHeight = ($('._sp .index-slider01-nav-item').eq(0).outerHeight(true)) - 60;
				} else {
					navHeight = $('._pc .index-slider01-nav-item').eq(0).outerHeight(true);
				}
				$('.index-slider01-item-bg').eq(i).height($(window).height() - navHeight);
			}
			$('.index-slider01').slick({
				autoplay: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				arrows: false,
				dots: false,
				fade:true,
				pauseOnFocus: false,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				asNavFor: '.index-slider01-nav',
				autoplaySpeed: 4000,
				speed: 1000,
				responsive: [{
					breakpoint: 1024,
					settings: {
						dots: true,
					}
				}]
			});
			$('.index-slider01-nav._pc').slick({
				asNavFor: '.index-slider01',
				slidesToShow: 4,
				focusOnSelect: true,
				infinite: false,
				autoplay: false,
				arrows: false
			});
			$('.index-slider01-nav._sp').slick({
				asNavFor: '.index-slider01',
				slidesToShow: 1,
				infinite: true,
				autoplay: true,
				fade:true,
				arrows: false,
				focusOnSelect: true
			});
			$('.index-main').removeClass('is-hidden');
			// console.log($(window).scrollTop());
			if($(window).scrollTop() > $(window).height()) {
				$('.header').addClass('is-visible');
			}
			$(window).scroll(function(e){
				var $this = $(e.currentTarget);
				var thisScroll = $this.scrollTop();
				if(thisScroll > $(window).height()) {
					$('.header').addClass('is-visible');
				} else {
					$('.header').removeClass('is-visible');
				}
			});
		} else {
			for(let i=0; i < $('.index-slider01-item-bg').length; i++) {
				let img = $('.index-slider01-item-bg').eq(i).data('img');
				$('.index-slider01-item-bg').eq(i).css('background-image', 'url('+img+')');
				if($(window).width() < 1025) {
					$('.index-slider01-item-bg').eq(i).height($(window).height() - 60);
				} else {
					$('.index-slider01-item-bg').eq(i).height(700);
				}
			}
			$('.index-slider01').slick({
				autoplay: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				arrows: true,
				prevArrow: '<a class="slick-prev opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
				nextArrow: '<a class="slick-next opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
				dots: true,
				fade:true,
				pauseOnFocus: false,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				autoplaySpeed: 6000,
				speed: 1000,
				responsive: [{
					breakpoint: 1024,
					settings: {
						dots: true,
					}
				}]
			});
			$('.index-main').removeClass('is-hidden');
			if($(window).scrollTop() > $(window).height()) {
				$('.header').addClass('is-visible');
			}
			$(window).scroll(function(e){
				var $this = $(e.currentTarget);
				var thisScroll = $this.scrollTop();
				if(thisScroll > $(window).height()) {
					$('.header').addClass('is-visible');
				} else {
					$('.header').removeClass('is-visible');
				}
			});
			setTimeout(function(){
				$(".index-slider01 .slick-current .index-inview").addClass(a);
				if($(".index-slider01 .slick-current .index-inview_top").length) {
					let cnt = 0;
					let timerId = setInterval(function(){
						$(".index-slider01 .slick-current .index-inview_top span").eq(cnt).addClass(a);
						cnt++;
						if(cnt==$(".index-slider01 .slick-current .index-inview_top span").length){
							$(".index-slider01 .slick-current ._button").addClass(a);
							clearInterval(timerId);
						}
					}, 50);
				}
			},200);
			$('.index-slider01').on('beforeChange', function(slick, currentSlide, nextSlide){
				$(".index-slider01 .slick-current .index-inview").removeClass(a);
				if($(".index-slider01 .slick-current .index-inview_top").length) {
					$(".index-slider01 .slick-current .index-inview_top span").removeClass(a);
					$(".index-slider01 .slick-current ._button").removeClass(a);
				}
			});
			$('.index-slider01').on('afterChange', function(slick, currentSlide){
				$(".index-slider01 .slick-current .index-inview").addClass(a);
				if($(".index-slider01 .slick-current .index-inview_top").length) {
					let cnt = 0;
					let timerId = setInterval(function(){
						$(".index-slider01 .slick-current .index-inview_top span").eq(cnt).addClass(a);
						cnt++;
						if(cnt==$(".index-slider01 .slick-current .index-inview_top span").length){
							$(".index-slider01 .slick-current ._button").addClass(a);
							clearInterval(timerId);
						}
					}, 50);
				}
			});
		}
	};

	const topicsSlider = () => {
		if($('.mod-slider-topics').length) {
			$('.mod-slider-topics').slick({
				autoplay: true,
				slidesToShow: 5,
				slidesToScroll: 1,
				infinite: true,
				dots: dotsFlg,
				arrows: true,
				prevArrow: '<a class="slick-prev opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
				nextArrow: '<a class="slick-next opacity" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
				responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						centerMode: true,
						centerPadding: '5%',
					}
				}]
			});
			$('.mod-slider-topics ._text').matchHeight();
			$('.mod-slider-topics ._title').matchHeight();
		}
	};

	indexMain();
});